import React from 'react';
import { useDropzone } from 'react-dropzone';

const DropZonefile = (props) => {
  const { content, onFileChange } = props; // Extracting props
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      // When a file is dropped, call the onFileChange function passed as prop//
      if (onFileChange) {
        onFileChange(acceptedFiles);
      }
    },
  });

  return (
    <div
      className="flex h-full !w-[700px] cursor-pointer items-center justify-center rounded-xl border-dashed border-navy-700"
      {...getRootProps({ className: 'dropzone' })}
    >
      <input {...getInputProps()} />
      <button className="h-full !w-full"> {content} </button>
    </div>
  );
};

export default DropZonefile;
